<fieldset [formGroup]="group" class="in-one-column">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <!-- type -->

  <mat-form-field>
    <app-easy-select
      formControlName="type"
      [label]="TITLE + 'TEQUILA_TYPE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.TEQUILA_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="types | toSelectOption: 'PRODUCTS.TEQUILA_TYPE.'"
    >
    </app-easy-select>
  </mat-form-field>
</fieldset>
